export default "__VITE_ASSET__72e1cbe8__"